export const APP_VERSION = {
  commitHash: 'f1b4d8a',
  pushedAt: '2026-11-04 12:34 AM EST',
};
